import script from "./AddInvoiceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddInvoiceModal.vue?vue&type=script&setup=true&lang=js"

import "./AddInvoiceModal.vue?vue&type=style&index=0&id=47ab8c40&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47ab8c40"]])

export default __exports__